import React from 'react';

function Avatar({ label }) {
  return (
    <svg viewBox="0 0 64 64" className="h-12 w-12">
      <circle cx="32" cy="22" r="12" fill="#f5d0a9" />
      <rect x="14" y="36" width="36" height="20" rx="10" fill="#93c5fd" />
      <text x="32" y="61" textAnchor="middle" className="fill-slate-600 text-[8px]">{label}</text>
    </svg>
  );
}

export default function SJTRenderer({ question, value, onChange }) {
  if (!question) return null;

  const optionEntries = Array.isArray(question.options)
    ? question.options.map((opt) => [opt.key, opt.text])
    : Object.entries(question.options || {});

  return (
    <div>
      <div className="rounded-2xl border border-amber-200/40 bg-[rgba(255,247,220,0.95)] p-5 text-slate-900">
        <p className="font-semibold tracking-wide">SCENARIO</p>
        <div className="mt-3 flex items-start gap-4">
          <Avatar label="Employee" />
          <Avatar label="Manager" />
          <p className="italic leading-7">{question.scenario || question.question}</p>
        </div>
      </div>

      <div className="mt-4 rounded-2xl border border-white/20 bg-slate-900/55 backdrop-blur-xl p-5">
        <p className="text-lg leading-8 font-cabinet text-white">{question.prompt || 'Choose the best response:'}</p>
      </div>

      <div className="mt-4 grid gap-3">
        {optionEntries.map(([key, text]) => {
          const selected = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              className={`w-full text-left px-4 py-3 rounded-xl border transition ${selected ? 'border-yellow-200 bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-600 text-slate-900' : 'border-white/25 bg-slate-800/60 text-white hover:border-yellow-200/70 hover:bg-slate-700/70'}`}
            >
              <span className="font-semibold mr-2">{key}.</span>
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
